import {
  Box,
  Button,
  Fade,
  IconButton,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { memo, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import { useSelector } from "react-redux";

export const CustomDateModal = memo(
  ({ open, onSave, onclose, start = "", end = "", customFY = {} }) => {
    const [modalStartDate, setModalStartDate] = useState(start);
    const [modalEndDate, setModalEndDate] = useState(end);
    const [error, setError] = useState({
      startDate: false,
      endDate: false,
    });

    console.log(modalStartDate, "modalStartDate");

    console.log(open, "open");

    const financialYear = useSelector(
      (state) => state?.userPrefrenceandReducer?.financialYear
    );
    const handleClose = (modalStartDate, modalEndDate) => {
      onclose(modalStartDate, modalEndDate);
      // setModalStartDate("");
      // setModalEndDate("");
    };

    const handleSave = () => {
      if (!modalStartDate || !modalEndDate) {
        setError({
          startDate: !modalStartDate,
          endDate: !modalEndDate,
        });
        return;
      }
      onSave(modalStartDate, modalEndDate);
    };

    useEffect(() => {
      const controlAndS = (e) => {
        // debugger
        if (e.ctrlKey && e.key.toLowerCase() === "s" && open) {
          e.preventDefault();
          handleSave();
        }
      };

      window.addEventListener("keydown", controlAndS);

      return () => {
        window.removeEventListener("keydown", controlAndS);
      };
    }, [modalStartDate, modalEndDate, open]);

    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
      >
        <Fade in={open}>
          <Paper
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              boxShadow: 24,
              outline: "none",
              minWidth: { xs: "80%", sm: "500px" },
            }}
          >
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ color: "#fff" }}>Custom Date</Typography>
              <IconButton aria-label="close" onClick={handleClose}>
                <CloseIcon sx={{ color: "#fff" }} />
              </IconButton>
            </Box>

            <Box sx={{ padding: "15px" }}>
              <Box
                sx={{
                  marginTop: 2,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Start Date */}
                <Typography sx={{ marginBottom: 1 }}>Start Date</Typography>
                <TextField
                  error={error.startDate}
                  variant="outlined"
                  size="small"
                  type="date"
                  fullWidth
                  value={modalStartDate}
                  onChange={(e) => {
                    setModalStartDate(e.target.value);
                    setError((prev) => ({ ...prev, startDate: false }));
                  }}
                  InputProps={{
                    inputProps: {
                      min: moment(
                        customFY?.startTimestamp
                          ? customFY.startTimestamp * 1000
                          : financialYear?.startdate * 1000
                      ).format("YYYY-MM-DD"),
                      max:
                        modalEndDate ||
                        moment(
                          customFY?.endTimestamp
                            ? customFY.endTimestamp * 1000
                            : financialYear?.enddate * 1000
                        ).format("YYYY-MM-DD"),
                    },
                  }}
                />
                {error.startDate && (
                  <Typography
                    sx={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    Start Date is required
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  marginTop: 3,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* End Date */}
                <Typography sx={{ marginBottom: 1 }}>End Date</Typography>
                <TextField
                  error={error.endDate}
                  variant="outlined"
                  size="small"
                  type="date"
                  fullWidth
                  value={modalEndDate}
                  onChange={(e) => {
                    setModalEndDate(e.target.value);
                    setError((prev) => ({ ...prev, endDate: false }));
                  }}
                  InputProps={{
                    inputProps: {
                      min: modalStartDate,
                      max: moment(
                        customFY?.endTimestamp
                          ? customFY.endTimestamp * 1000
                          : financialYear?.enddate * 1000
                      ).format("YYYY-MM-DD"),
                    },
                  }}
                />
                {error.endDate && (
                  <Typography
                    sx={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    End Date is required
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  marginTop: 3,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  onClick={handleClose}
                  variant="outlined"
                  sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleSave}
                  variant="contained"
                  sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Paper>
        </Fade>
      </Modal>
    );
  }
);

export default CustomDateModal;
